<ng-container *transloco="let t">
  <div class="toast-relative-container" #relativeContainer>
    <div class="toast-slide-container">
      <div
        class="toast align-items-center border-0"
        [ngClass]="{
          success: type === ToastType.Success,
          warning: type === ToastType.Warning,
          error: type === ToastType.Error,
          info: type === ToastType.Info,
        }"
      >
        <div class="d-flex justify-content-between">
          <div class="toast-body" #toastBody>
            @if (type === ToastType.Warning) {
              <lib-icon name="alert-circle"></lib-icon>
            }
            @if (type === ToastType.Info) {
              <lib-icon name="bell"></lib-icon>
            }
            <span class="toast-message">
              {{ t(messageKey) }}
            </span>
          </div>
          <button
            vinnova-button-text
            size="small"
            (click)="hide()"
            class="close-button"
            [attr.aria-label]="closeLabel"
          >
            <lib-icon name="x"></lib-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
